import { graphql, useStaticQuery } from "gatsby";
import { getImage } from 'gatsby-plugin-image';

export const svgExtension = 'svg'

export const useImages = () => {
    const data = useStaticQuery(graphql`
        query {
            allFile {
                edges {
                    node {
                        relativePath
                        publicURL
                        extension
                        childImageSharp {
                            gatsbyImageData
                        }
                    }
                }
            }
        }
    `);

    const handleImages = text => {
        const images = data.allFile.edges.reduce((images, edge) => {
            if (edge.node.extension === svgExtension) {
                images[edge.node.relativePath] = edge.node.publicURL;
            } else if (edge.node.childImageSharp) {
                images[edge.node.relativePath] = edge.node.childImageSharp.gatsbyImageData;
            }
            return images;
        }, {});

        let img = ''
        if (text.includes(svgExtension)) {
            img = images[text]
        } else {
            img = getImage(images[text])
        }
        return img
    }

    return { handleImages }
}